import {isNil} from 'ramda';

import {TranslationResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {isPremiumInteriorMaterial} from '../../../constants/PREMIUM_INTERIOR_MATERIALS';
import {HighlightItemType} from '../types/HighlightItemType';

/**
 * Interior material flag shown in front of the highlighted features, with a seat icon and
 * "Interior material" on hover. Only premium materials (leather, Alcantara) get a flag.
 */
export const getInteriorMaterialHighlights = (
  interiorMaterial: TranslationResponseBody | Nullish
): HighlightItemType[] => {
  if (isNil(interiorMaterial) || !isPremiumInteriorMaterial(interiorMaterial.key)) {
    return [];
  }

  return [
    {
      key: `interiorMaterial-${interiorMaterial.key}`,
      label: interiorMaterial.translation,
      colorScheme: 'blue',
      isSubtle: true,
      tooltip: i18n.t('entity.vehicle.labels.interiorMaterial'),
      icon: 'action/event_seat',
    },
  ];
};
